const monthsDictionary = [
  'Gennaio',
  'Febbraio',
  'Marzo',
  'Aprile',
  'Maggio',
  'Giugno',
  'Luglio',
  'Agosto',
  'Settembre',
  'Ottobre',
  'Novembre',
  'Dicembre',
]

export const formatApiStringToDate = (
  date: Maybe<string>
): Date | undefined => {
  if (!date) {
    return
  }
  // date format from api is 2020/02/21 (yyyy/mm/dd)
  const dateArray = date.split('-')
  if (dateArray.length !== 3) {
    return
  }
  const dateString = `${dateArray[1]}/${dateArray[2]}/${dateArray[0]}`
  return new Date(dateString)
}

export const formatDateToApiString = (
  date: Date | null
): string | undefined => {
  if (!date) {
    return
  }
  const dateObj = new Date(date)

  return `${dateObj.getDate()}/${dateObj.getMonth() +
    1}/${dateObj.getFullYear()}`
}

export const formatDateToApiIsoString = (
  date: Date | null
): string | undefined => {
  if (!date) {
    return
  }
  return date.toISOString()
}

export const formatApiIsoDate = (
  date: string,
  withTime?: boolean,
  excludeSeconds?: boolean,
  separator?: string
) => {
  // Exclude seconds from date
  const options = {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    seconds: '2-digit',
  }

  const stringDate = !withTime
    ? new Date(date).toLocaleDateString('it')
    : excludeSeconds
    ? new Date(date).toLocaleString('it', options)
    : new Date(date).toLocaleString('it')

  return separator ? stringDate.replace(/,/g, separator) : stringDate
}

export const formatDateString = (isoString: string, prefix?: string) => {
  if (!isoString) {
    return ''
  }

  const dateJs = new Date(isoString.split('T')[0])

  if (Number.isNaN(dateJs.getTime())) {
    return ''
  }

  const day = dateJs.getDate()
  const month = dateJs.getMonth()
  const year = dateJs.getFullYear()

  return `${prefix || ''}${day} ${monthsDictionary[month]} ${year}`
}

// format iso string to dd/mm/yyyy
export const formatDateShort = (date: Date | string) => {
  const validDate = typeof date === 'string' ? new Date(date) : date
  const day = `${validDate.getDate()}`.padStart(2, '0')
  const month = `${validDate.getMonth() + 1}`.padStart(2, '0')
  const year = validDate.getFullYear()
  return `${day}/${month}/${year}`
}
